import { Component, Input, OnInit } from "@angular/core";
import { FromToDetail } from "../../../../../_objects/report-element";
import { ReportTable } from "../../../../models/report-preview/report-table";
import { MousePoint, Notifier, OfflineReportPreviewService } from "../../../../../_services/offline-report-preview.service";

@Component({
  selector: "app-report-table",
  templateUrl: "./report-table.component.html",
  styleUrls: ["./report-table.component.scss"],
  standalone: false
})
export class ReportTableOfflineComponent implements OnInit {
  @Input() public pageKey: string;
  @Input() public tableKey: string;
  @Input() public elementLocation: string;

  public notifier: Notifier;
  public reportTable: ReportTable;
  public resizeMarkerSize: number;
  public resizing: boolean;

  readonly uprightTextStyle = "writing-mode: vertical-lr; text-orientation: mixed; margin: auto;";
  readonly contentFitStyle = "width: 95%;";
  readonly tableStyle = "border-collapse: collapse; table-layout: fixed;";

  constructor(public designService: OfflineReportPreviewService) {
    this.resizeMarkerSize = 36;
    this.resizing = false;
  }

  public ngOnInit() {
    this.notifier = {
      componentName: "report-table.component",
      ids: { pageId: this.pageKey, elementId: this.tableKey }
    };
    this.reportTable = this.designService.getTable(this.tableKey);
  }

  public onClick(event: MouseEvent) {}

  public onDragStart(event: DragEvent) {
    // console.log('ReportImage onDragStart');
    event.dataTransfer.setData("text", this.tableKey);
    event.dataTransfer.effectAllowed = "move";

    const fromDetail: FromToDetail = {
      location: this.reportTable.getLocation(),
      pageId: this.pageKey
    };
    const dragPoint: MousePoint = {
      onElementX: event.offsetX,
      onElementY: event.offsetY
    };
  }

  public onDragOver(event: DragEvent) {
    // console.log('ReportImage onDragOver');
    event.preventDefault();
    event.dataTransfer.dropEffect = "move";
    event.stopPropagation();
  }

  public onDrop(event: DragEvent) {
    // console.log('ReportImage onDrop');
    event.preventDefault();
    const template = { ...this.designService.originTemplate };
    template.reportTemplateContent = JSON.stringify(this.designService.getTemplate());
    const dragElemId = event.dataTransfer.getData("text");

    const toDetail: FromToDetail = {
      location: this.reportTable.getLocation(),
      pageId: this.pageKey
    };
    const dropPoint: MousePoint = {
      onElementX: this.reportTable.getLeftPx() + event.offsetX,
      onElementY: this.reportTable.getTopPx() + event.offsetY
    };

    event.dataTransfer.clearData("text");
    event.stopPropagation();
  }

  public getResizeMarkerSize(): string {
    return this.resizeMarkerSize + "px";
  }

  public getResizeMarkerLeft(horizontal: string): string {
    switch (horizontal) {
      case "left":
        return (this.resizeMarkerSize / 2) * -1 + "px";
      case "center":
        return this.reportTable.getWidthPx() / 2 - this.resizeMarkerSize / 2 + "px";
      case "right":
        return this.reportTable.getWidthPx() - this.resizeMarkerSize / 2 + "px";
      default:
        return "";
    }
  }

  public getResizeMarkerTop(vertical: string): string {
    switch (vertical) {
      case "top":
        return (this.resizeMarkerSize / 2) * -1 + "px";
      case "middle":
        return this.reportTable.getHeightPx() / 2 - this.resizeMarkerSize / 2 + "px";
      case "bottom":
        return this.reportTable.getHeightPx() - this.resizeMarkerSize / 2 + "px";
      default:
        return "";
    }
  }

  public onResizeMarkerDown(event: MouseEvent, vertical: string, horizontal: string) {
    // console.log('reportTable onResizeMarkerDown');
    event.preventDefault();
    this.resizing = true;
    const beginPoint: MousePoint = {
      onElementX: event.offsetX,
      onElementY: event.offsetY
    };

    event.stopPropagation();
  }

  public onResizing(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  public onResizeMarkerUp(event: MouseEvent) {
    event.preventDefault();
    this.resizing = false;
    event.stopPropagation();
  }

  public onResizeMarkerLeave(event: MouseEvent) {
    event.preventDefault();
    this.resizing = false;
    event.stopPropagation();
  }
}
